const getMandatesList = state => state?.mandates?.mandatesList?.result || state?.mandates?.mandatesList || []
const getSingleMandate = state => state?.mandates?.singleMandate
const getMandatesLoading = state => state?.mandates?.loading || false
const getMandateMetrics = state => state?.mandates?.metrics

const selectors = {
  getMandatesList,
  getSingleMandate,
  getMandatesLoading,
  getMandateMetrics,
}

export default selectors
